import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutomatedSmartIrrigationSchedule } from 'src/api/models';

export interface AutomatedScheduleEditorRecord {
  id: number | null;
  day: string;
  startHour: number;
  endHour: number;
  cutoff?: number;
  editing?: boolean;
}

@Component({
  selector: 'app-automated-schedule-editor',
  templateUrl: './automated-schedule-editor.component.html'
})
export class AutomatedScheduleEditorComponent {
  private daysOfWeek: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  editSchedules: AutomatedScheduleEditorRecord[] = [];

  @Input() set schedules(value: AutomatedSmartIrrigationSchedule[] | null | undefined) {
    this.editSchedules = (value || []).map(schedule => ({
      id: schedule.id,
      day: this.daysOfWeek[schedule.dayOfWeek],
      startHour: this.getHour(schedule.startTime),
      endHour: this.getHour(schedule.endTime) - 1,
      cutoff: schedule.irrigationCutoff
    }));
  }

  @Output() scheduleChange = new EventEmitter<AutomatedScheduleEditorRecord>();
  @Output() scheduleAdd = new EventEmitter<AutomatedScheduleEditorRecord>();
  @Output() scheduleDelete = new EventEmitter<AutomatedScheduleEditorRecord>();
  @Output() clearSchedules = new EventEmitter<void>();

  private getHour(time: string): number {
    if (time.indexOf('.') >= 0) {
      return 24;
    }

    return parseInt(time.split(':')[0], 10);
  }
}